import makeBulkContext from './makeBulkContext';

export const {
  Provider: BulkSearchContextProvider,
  useContext: useBulkSearchContext,
} = makeBulkContext();
